import {Component, Input} from '@angular/core';
import {OrderForm} from '../../models/order-form';
import {OrderFormService} from '../../services/order-form.service';
import {UserLogged} from '../../models/userLogged';

@Component({
  selector: 'app-market-data-summary',
  templateUrl: './market-data-summary.component.html',
  styleUrls: ['./market-data-summary.component.scss']
})
export class MarketDataSummaryComponent {

  @Input()
  currentUser: UserLogged;
  orderForms: OrderForm[];

  constructor(private orderFormService: OrderFormService) {
  }

  @Input()
  set selected(selected: boolean) {
    if (selected) {
      this.getOrderForms();
    }
  }

  getOrderForms() {
    this.orderFormService.getMarketDataOrderForms(this.currentUser.company.uniqid).subscribe(
      orderForms => {
        this.orderForms = orderForms;
        this.orderForms.forEach(orderForm => {
          if (orderForm.executionDate) {
            orderForm.executionDate = new Date(orderForm.executionDate);
          }
          if (orderForm.endDate) {
            orderForm.endDate = new Date(orderForm.endDate);
          }
        });
      }
    );
  }
}
